import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputDateUI from '../../../widgets/form/InputDateUI'

const DisbursementModalUI = ({context, successMsg, errorList, setErrorList,
    // modes
    updateMode, submitted,
    // event handlers
    onSubmit, onCancelClick,
    // fields
    disbursementDate, onDisbursementDateChange, disbursementDateError, setDisbursementDateError,
    disbursementAmount, onDisbursementAmountChange, disbursementAmountError, setDisbursementAmountError,
  }) =>
  <ModalFormUI
    context={context}
    titleLabel='Add disbursement'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <div className='g_muted'>
      This form creates a repayment schedule, but does not create bank transactions
      and does not send disbursement letter.
    </div>
    <InputDateUI context={context} name='disbursementDate' required={true} label='Disbursement date'
      selectedDateISO={disbursementDate} onChange={onDisbursementDateChange}
      error={disbursementDateError} setError={setDisbursementDateError}
    />
    <InputTextSF type='text' name='disbursementAmount' label='Disbursement amount (optional)'
      value={disbursementAmount} onChange={onDisbursementAmountChange} maxLength={10}
      error={disbursementAmountError} setError={setDisbursementAmountError}
      help='Defaulted to sanction amount if not entered'
    />
  </ModalFormUI>

export default DisbursementModalUI
